import { UserLevel, UserVerificationStatus } from 'src/type/user';

export const verificationStatusOption = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'รอเอกสาร',
    value: UserVerificationStatus.PENDING,
  },
  {
    label: 'รอการยืนยัน',
    value: UserVerificationStatus.PROCESSING,
  },
  {
    label: 'ยืนยันแล้ว',
    value: UserVerificationStatus.VERIFIED,
  },
  {
    label: 'ปฏิเสธ',
    value: UserVerificationStatus.REJECTED,
  },
];

export const levelOptions = [
  { label: 'ทุกระดับ', value: 'all' },
  { label: 'ระดับ 0', value: UserLevel.LV0 },
  { label: 'ระดับ 1', value: UserLevel.LV1 },
  { label: 'ระดับ 2', value: UserLevel.LV2 },
  { label: 'ระดับ 3', value: UserLevel.LV3 },
  { label: 'ระดับ 4', value: UserLevel.LV4 },
  { label: 'ระดับ 5', value: UserLevel.LV5 },
];

export const verificationStatusLabel = (status: UserVerificationStatus) =>
  verificationStatusOption.find((item) => item.value === status)?.label || '';

export const levelLabel = (level: UserLevel | string) =>
  levelOptions.find((item) => item.value === level)?.label || '';
